// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__mAixm","button_reset":"Button_button_reset__dX7RQ"};